import { Flex } from "antd";
import { FC, useMemo, useState } from "react";
import {
    AssortmentTaskType,
    Point,
    SubtaskFinGroupPhotosPayload,
    TaskAssortmentMatrix,
} from "tm-shared/types";

import {
    CustomTaskFromTaskButton,
    TaskViewModal,
} from "@/features/TaskView/components";

import { AssortmentMatrixSubtaskView } from "./ProductsMatrixSubtaskView";
import { StepsSection } from "./StepsSection";

interface AssortmentMatrixViewModalProps {
    task: TaskAssortmentMatrix;
    point: Point;
    onClose: () => void;
}

export const AssortmentMatrixViewModal: FC<AssortmentMatrixViewModalProps> = ({
    task,
    point,
    onClose,
}) => {
    const { payload, context, completedAt, name, info } = task;

    const [step, setStep] = useState(0);

    const taskImages = useMemo(() => {
        if (!payload) return [];

        const photoTask = Object.values(payload).find(
            (item): item is SubtaskFinGroupPhotosPayload =>
                item.type === AssortmentTaskType.FinGroupPhotos,
        );

        if (!photoTask?.tasks) return [];

        return Object.values(photoTask.tasks).flatMap(
            (task) => task.photos ?? [],
        );
    }, [payload]);

    if (!payload || !completedAt) return null;

    const { subtasks } = context;
    const currentSubtask = subtasks[step];

    if (!currentSubtask) return null;

    const currentPayload = payload[currentSubtask.subtaskId];

    return (
        <TaskViewModal title={name} onClose={onClose} taskInfo={info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    point={point}
                    images={taskImages}
                />

                <StepsSection
                    subtasks={subtasks}
                    currentStep={step}
                    onStepChange={setStep}
                />

                {currentPayload && (
                    <AssortmentMatrixSubtaskView
                        subtask={currentSubtask}
                        payload={currentPayload}
                    />
                )}
            </Flex>
        </TaskViewModal>
    );
};
